<template>
	<div>
		<div>
			<h5>Clientes</h5>
		</div>
		<table class="table table-borderless">
			<tbody>
				<tr v-for="cliente in clientes">
					<td width="20px">
						<div class="custom-control custom-checkbox">
							<input type="checkbox" class="custom-control-input" :id="'chk'+cliente.CODIGO_CLIENTE" v-on:click="addClient(cliente.CODIGO_CLIENTE)" :value="cliente.CODIGO_CLIENTE" v-model="userClients">
							<label :for="'chk'+cliente.CODIGO_CLIENTE" class="custom-control-label"></label>
						</div>
					</td>
					<td>
						<label :for="'chk'+cliente.CODIGO_CLIENTE">
							{{cliente.DESCRIPCION}}
						</label>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		props: ['usuario'],

		mounted() {
			this.getClientes();
			this.getUsers();
	    },

	    data(){
        	return {
        		clientes: [],
        		userClients: [],
        		loading: false,
        		mensaje: '',
        	}
        },

        methods: {
        	getClientes: function(){
        		this.loading = true;
        		this.mensaje = 'cargando...';
				var url = '/api/clientes-bases/index';
				axios.get(url).then(response => {
					this.clientes = response.data;
				}).catch(error =>{
				  console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			getUsers: function(){
        		this.loading = true;
        		this.mensaje = 'cargando...';
				var url = '/api/usuarios-clientes/showClientsUser/'+this.usuario;
				axios.get(url).then(response => {
					console.log(response.data);
					this.userClients = response.data;
				}).catch(error =>{
				  console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			addClient: function(cliente){
				this.loading = true;
        		this.mensaje = 'cargando...';
				var url = '/api/usuarios-clientes';
				axios.post(url, {
					usuario: this.usuario,
					cliente: cliente,
				}).then(response => {
					this.getClientes();
					this.$toasted.show(response.data);
				}).catch(error =>{
				  console.log(error.response);
				  this.getClientes();
				  this.$toasted.show('Error al asignar cliente');
				}).then(()=>{
					this.loading = false;
				});	
			},
		}
	}
</script>